import React from 'react'
import { ResponsivePie } from '@nivo/pie';

const EventsPieChart = ({events}) => {

  const data = events;

    
      return (
        <div style={{ height: '25vh', width:"100%" }}>
        <h4 style={{marginTop:"-1em"}}>Event Categories Breakdown</h4>
          <ResponsivePie
            data={data.map(item => ({ id: item.category, value: item.totalEvents }))}
            margin={{ top: 10, right: 0, bottom: 60, left: 0 }}
            innerRadius={0}
            padAngle={0}
            activeOuterRadiusOffset={8}
            borderWidth={1}
            borderColor={{
              from: 'color',
              modifiers: [['darker', 0.2]],
            }}
            enableArcLinkLabels={false}
            fill={data.map(item => ({
              match: { id: item.category },
              id: item.category === "Music" || item.category === "Sports" || item.category === "Charity Event" || item.category === "Job Event" ? 'dots' : 'lines',
            }))}
            legends={[
              {
                anchor: 'bottom',
                direction: 'row',
                justify: false,
                translateX: 0,
                translateY: 56,
                itemsSpacing: 10,
                itemWidth: 100,
                itemHeight: 18,
                itemTextColor: '#999',
                itemDirection: 'left-to-right',
                itemOpacity: 1,
                symbolSize: 18,
                symbolShape: 'circle',
                effects: [
                  {
                    on: 'hover',
                    style: {
                      itemTextColor: '#000',
                    },
                  },
                ],
              },
            ]}
          />
        </div>
      );
    };

export default EventsPieChart